import type { IDebtRepository } from './types'
import type { ILedgerRepository } from './ledgerTypes'
import type { IRecurringExpenseRepository } from './recurringExpenseTypes'
import type { IRecoveryAnchorRepository } from './recoveryAnchorTypes'
import { LocalStorageRepo } from './localStorageRepo'
import { LocalStorageLedgerRepo } from './localStorageLedgerRepo'
import { LocalStorageRecurringExpenseRepo } from './localStorageRecurringExpenseRepo'
import { LocalStorageRecoveryAnchorRepo } from './localStorageRecoveryAnchorRepo'

export type {
  IDebtRepository,
  ILedgerRepository,
  IRecurringExpenseRepository,
  IRecoveryAnchorRepository,
}
export {
  LocalStorageRepo,
  LocalStorageLedgerRepo,
  LocalStorageRecurringExpenseRepo,
  LocalStorageRecoveryAnchorRepo,
}

// ─── Debt repository singleton ────────────────────────────────────
let _repo: IDebtRepository = new LocalStorageRepo()

export function getRepository(): IDebtRepository {
  return _repo
}

export function setRepository(repo: IDebtRepository): void {
  _repo = repo
}

// ─── Ledger repository singleton ──────────────────────────────────
let _ledgerRepo: ILedgerRepository = new LocalStorageLedgerRepo()

export function getLedgerRepository(): ILedgerRepository {
  return _ledgerRepo
}

export function setLedgerRepository(repo: ILedgerRepository): void {
  _ledgerRepo = repo
}

// ─── Recurring expense repository singleton ───────────────────────
let _expenseRepo: IRecurringExpenseRepository = new LocalStorageRecurringExpenseRepo()

export function getRecurringExpenseRepository(): IRecurringExpenseRepository {
  return _expenseRepo
}

export function setRecurringExpenseRepository(repo: IRecurringExpenseRepository): void {
  _expenseRepo = repo
}

// ─── Recovery anchor repository singleton ─────────────────────────
let _recoveryAnchorRepo: IRecoveryAnchorRepository = new LocalStorageRecoveryAnchorRepo()

export function getRecoveryAnchorRepository(): IRecoveryAnchorRepository {
  return _recoveryAnchorRepo
}

export function setRecoveryAnchorRepository(repo: IRecoveryAnchorRepository): void {
  _recoveryAnchorRepo = repo
}
